import {Box, Card, CardContent, CardHeader, Divider, Typography} from '@mui/material';
import { styled } from '@mui/material/styles';
// import JsonTree from '../common/JsonTree';
import {Booking} from '../../api/types';
import {useTranslation} from 'react-i18next';
const PREFIX = 'BookingRawInfo';

const classes = {
    bookingRawData: `${PREFIX}-bookingRawData`,
};

const StyledCard = styled(Card)(() => ({
    [`& .${classes.bookingRawData}`]: {
        marginTop: '10px',
    },
}));

interface BookingRawInfoProps {
    booking: Booking;
}

const BookingRawInfo = (props: BookingRawInfoProps) => {

    const {t} = useTranslation();

    return (
        <StyledCard>
            <CardHeader title={t('common.raw_data')} />
            <Divider />
            <CardContent>
                <Box className={classes.bookingRawData}>
                    <Typography variant={'body2'} component={'div'}>
                        {/* <JsonTree data={props.booking.rawData} /> */}
                    </Typography>
                </Box>
            </CardContent>
        </StyledCard>
    );
};

export default BookingRawInfo;
